import type { StyleHandler } from '@/teoCore/text/StyleHandler';
import type { PillGroup } from '@/ui/elements/tpi-drawer/TPIDrawer.svelte';

export type StylePillGroup = Omit<PillGroup, 'key'> & { key: string };

export function createPillGroups(style: StyleHandler): StylePillGroup[] {
  // {
  //   id: '0',
  //   key: 'sentiment',
  //   label: '(TODO) Sentiment Scanner',
  //   score: undefined,
  //   used: true,
  //   pills: [
  //     {
  //       id: '0',
  //       key: 'negative',
  //       type: 'MarkerPillData',
  //       label: 'Negative Ausdrücke',
  //       value: 1,
  //     },
  //     {
  //       id: '1',
  //       key: 'neutral',
  //       type: 'MarkerPillData',
  //       label: 'Neutrale Ausdrücke',
  //       value: 3,
  //     },
  //     {
  //       id: '2',
  //       key: 'postive',
  //       type: 'MarkerPillData',
  //       label: 'Positive Ausdrücke',
  //       value: 2,
  //     },
  //   ],
  // },

  const values = style.styleValues;

  const pillGroups: StylePillGroup[] = Object.entries(values).map(([category, data], idx) => ({
    id: idx.toString(),
    key: category,
    label: data.label,
    score: undefined,
    used: true,
    pills: data.text_propertis.map((prop, pidx): PillGroup['pills'][number] => ({
      id: pidx.toString(),
      key: prop.name,
      type: 'MarkerPillData',
      label: prop.label,
      value: prop.value,
    })),
  }));

  return pillGroups;
}
